import { Typography } from '@mui/material';
import { theme } from '../../../theme';
import JoinUsList from './JoinUsList';
import { ThemeProvider } from '@mui/material/styles';

const JoinUsManagement = () => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Join Us Requests
      </Typography>
      <JoinUsList />
    </ThemeProvider>
  );
};

export default JoinUsManagement;